export const FREE = 1;
export const PREMIUM = 2;
export const EXPIRED_PREMIUM = 3;
export const NEAR_ENDING_PREMIUM = 4;

export default {
  FREE: 1,
  PREMIUM: 2,
  EXPIRED_PREMIUM: 3,
  NEAR_ENDING_PREMIUM: 4
};

export const PURCHASE_ACTION_NAMES = {
  [FREE]: "خرید طرح",
  [EXPIRED_PREMIUM]: "خرید طرح",
  [PREMIUM]: "تغییر طرح",
  [NEAR_ENDING_PREMIUM]: "تمدید طرح",
  isGift: "خرید طرح"
};